import { render, staticRenderFns } from "./paste-dialog.vue?vue&type=template&id=85dfb79c&scoped=true"
import script from "./paste-dialog.vue?vue&type=script&lang=js"
export * from "./paste-dialog.vue?vue&type=script&lang=js"
import style0 from "./paste-dialog.vue?vue&type=style&index=0&id=85dfb79c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dfb79c",
  null
  
)

export default component.exports